import styled from '@emotion/styled';
import { Avatar, LinearProgress, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

export type Props = ClassAttributes<HTMLElement> & {
  file: File | { name: string };
  className?: string;
  progress: number;
  state: 'uploading' | 'downloading';
};

const FileListUploadingItem = ({ file, className, progress, state }: Props) => {
  return (
    <Root>
      <ListItem className={className}>
        <ListItemIcon>
          <Avatar>
            <CloudUpload />
          </Avatar>
        </ListItemIcon>

        <ListItemText
          primary={
            <Typography variant="subtitle1" noWrap>
              {file.name}
            </Typography>
          }
          secondary={
            <Secondary>
              <Label variant="body2" color="textSecondary">
                <FormattedMessage id={`file_list.file_list_uploading_item.${state}`} />
              </Label>
              <Progress>{progress}%</Progress>
              <ProgressBar>
                <LinearProgress variant="determinate" value={progress} />
              </ProgressBar>
            </Secondary>
          }
          disableTypography
        />
      </ListItem>
    </Root>
  );
};

const Root = styled('div')`
  background-color: #e5e7ec;
`;

const Secondary = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'auto auto 1fr',
  gridTemplateAreas: "'label progress progressBar'",
});

const Label = styled(Typography)({
  gridArea: 'label',
  marginRight: 8,
});

const Progress = styled(Typography)({
  gridArea: 'progress',
  marginRight: 16,
});

const ProgressBar = styled('div')({
  gridArea: 'progressBar',
  padding: '7.5px 0',
});

export default FileListUploadingItem;
